import React, { useCallback, useEffect, useRef, useState } from 'react'

const useImageLightbox = () => {
	const [lightboxSrc, setLightboxSrc] = useState<string | null>(null)
	const overlayRef = useRef<HTMLDivElement>(null) as React.RefObject<HTMLDivElement>

	useEffect(() => {
		const handleImageClick = (e: Event) => {
			const target = e.target as HTMLElement
			if (target.tagName === 'IMG') {
				const img = target as HTMLImageElement
				setLightboxSrc(img.src)
			}
		}

		const manualContent = document.querySelector('.manual-content-area')
		if (manualContent) {
			manualContent.addEventListener('click', handleImageClick)
		}

		return () => {
			if (manualContent) {
				manualContent.removeEventListener('click', handleImageClick)
			}
		}
	}, [])

	const closeLightbox = useCallback(() => setLightboxSrc(null), [])

	useEffect(() => {
		if (!lightboxSrc) return

		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
		document.body.style.overflow = 'hidden'
		document.body.style.paddingRight = `${scrollbarWidth}px`

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				overlayRef.current?.classList.add('visible')
			})
		})

		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key === 'Escape') closeLightbox()
		}
		document.addEventListener('keydown', handleKeyDown)

		return () => {
			document.body.style.overflow = ''
			document.body.style.paddingRight = ''
			document.removeEventListener('keydown', handleKeyDown)
		}
	}, [lightboxSrc, closeLightbox])

	return { lightboxSrc, closeLightbox, overlayRef }
}

export default useImageLightbox
